import CopyFieldToClipboard from './CopyFieldToClipboard'
import N2StylesModal from './N2StylesModal'

export default class ShareAssetModal {
  constructor(opts) {
    this.selector = opts.selector || '#share-asset-modal';
    this.show(opts);
  }

  show(opts) {
    new CopyFieldToClipboard();
    new N2StylesModal(this.selector);
    let params = { share_link: { asset_id: opts.asset_id, expires_at: opts.expiresAt }}
    let self = this;
    
    $.ajax({
      type: "POST",
      url: '/shortened_url_links',
      data: params,
      dataType: 'json',
      success: function(resp) {
        $("input[name='js-share-link']").val(resp.link)
      },
      error: function(resp) {
        $(self.selector).modal('hide')
        toastr.options["positionClass"] = "toast-bottom-center";
        toastr["info"]("Something has gone wrong. Please try again soon.");
      }
    });
  }
}
